import { render, staticRenderFns } from "./CreateOrUpdatePatient.vue?vue&type=template&id=08fa7bd4&scoped=true"
import script from "./CreateOrUpdatePatient.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdatePatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fa7bd4",
  null
  
)

export default component.exports